/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    colorTheme = "colorTheme",
    overrideTitle = "overrideTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.colorTheme]: "light" | "dark";
        [fields.overrideTitle]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => (
    <Typography
        variant="h2"
        as="h1"
        data-test-selector="PageTitle"
        className={fields?.colorTheme === "dark" ? "dark" : "light"}
        css={css`
            &.dark {
                color: ${getColor("common.white")};
            }
        `}
    >
        {fields?.overrideTitle || pageTitle}
    </Typography>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                name: fields.colorTheme,
                editorTemplate: "DropDownField",
                defaultValue: "light",
                fieldType: "General",
                options: [
                    { displayName: "Light", value: "light" },
                    { displayName: "Dark", value: "dark" },
                ],
            },
            {
                name: fields.overrideTitle,
                editorTemplate: "TextField",
                fieldType: "Translatable",
                isRequired: false,
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
